import type { InfoAccordionsProps } from './info-accordions.d';

import React from 'react';
import { InfoAccordions } from '/react4xp/parts/infoAccordions/InfoAccordions';


export default function (props: /* React.JSX.IntrinsicAttributes & */ InfoAccordionsProps): JSX.Element {
	return <InfoAccordions {...props} />;
}
